/**
 * File: themeSummaryController.js
 * Project: educore
 * Created Date: 2018-12-06
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class ThemeSummaryController {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state, AUTHDASHCONSTANT) {

        let authoring;

        //On init function
        // this.$onInit = () => {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            })
        } else {
            authoring = localStorageService.get("authoringData")
            if (authoring) {
                $rootScope.authMenu = true;
                $rootScope.title = authoring.class + "" + authoring.batch + "/" + authoring.curriculum + "/" + authoring.session + "/" + authoring.subject
            } else {
                $state.go("authdashboard")
            }
        }
        // }

        //On destroy function
        this.$onDestroy = () => {
            authoring = "";
            themeId = "";
            userId = "";
            reportAccess = "";
            $scope.userAccess = {};
            params = "";
            $scope.isAttendanceTaken = "";
            $scope.attendance = "";
            $scope.planList = "";
            $scope.themeName = "";
        }

        //String  - Theme id
        let themeId = $state.params.theme_id

        //String - userId
        let userId = localStorageService.get("user_id")

        //Roles and Privileges
        // UserPrivilages.getUserPrivilageInitialSetting(function(result) {
        // if (result.module_privileges.findIndex(module => module.state === "authdashboard") === -1) {
        //     $state.go('dashboard')
        // }
        // let reportAccess = UserPrivilages.getFeatures("reports")
        let reportAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state === "reports"
        })
        $scope.userAccess = {};
        if (reportAccess.length > 0) {
            _.each(reportAccess, function(rpObj) {
                let user_access = {};
                _.each(rpObj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.userAccess[rpObj.feature_id] = user_access;
            })
        }
        let tpAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state === "teachingPlan"
        })
        $scope.tpUserAccess = {};
        if (tpAccess.length > 0) {
            _.each(tpAccess, function(rpObj) {
                let user_access = {};
                _.each(rpObj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.tpUserAccess[rpObj.feature_id] = user_access;
            })
        }
        // })


        //Object - academic details
        let params = {
            session_id: authoring.session_id,
            curriculum_id: authoring.curriculum_id,
            class_id: authoring.class_id,
            batch_id: authoring.batch_id,
            theme_id: themeId,
            school_id: authoring.school_id,
            academic_year: authoring.academic_year,
            user_id: userId,
            overviewReport: $scope.userAccess.overviewReport
        }
        authService.callAPI(AUTHDASHCONSTANT.API_THEME_SUMMARY_URL, "POST", params, function(response) {
            let result = response.result.data
            if (result) {
                result.plans = _.filter(result.plans, function(plan) {
                    return plan._id != null
                })
                let teachingPlans = result.plans;
                $scope.planList = []
                //Developer- Raziya
                //start
                //To get only assigned teaching plan for students
                _.each(teachingPlans, function(tp) {
                        if ($scope.tpUserAccess) {
                            if ($scope.tpUserAccess.approvedPlans && $scope.tpUserAccess.approvedPlans.read) {
                                if (tp.status === AUTHDASHCONSTANT.STATUS_APPROVED) {
                                    if (tp.teacher_id === userId) {
                                        $scope.planList.push(tp);
                                    }
                                    // Display teaching plan to assigned students only
                                    if (tp.students && tp.students.length > 0) {
                                        _.each(tp.students, function(student) {
                                            if (student === userId) {
                                                $scope.planList.push(tp)
                                            }
                                        })
                                    }
                                }
                            }
                            if ($scope.tpUserAccess.rejectedPlans && $scope.tpUserAccess.rejectedPlans.read) {
                                if (tp.status === AUTHDASHCONSTANT.STATUS_REJECTED) {
                                    if (tp.teacher_id === userId)
                                        $scope.planList.push(tp);
                                }
                            }
                            if ($scope.tpUserAccess.newTeachingPlan && $scope.tpUserAccess.newTeachingPlan.read) {
                                if (tp.status === AUTHDASHCONSTANT.STATUS_CREATED || tp.status === AUTHDASHCONSTANT.STATUS_DRAFT) {
                                    if (tp.teacher_id === userId)
                                        $scope.planList.push(tp);
                                }
                            }
                            if ($scope.tpUserAccess.sentForApprovalPlans && $scope.tpUserAccess.sentForApprovalPlans.read) {
                                if (tp.status === AUTHDASHCONSTANT.STATUS_SENT_FOR_APPROVAL) {
                                    if (tp.teacher_id === userId)
                                        $scope.planList.push(tp);
                                }
                            }
                        }
                    })
                // end
                if (result.attendance) {
                    $scope.isAttendanceTaken = true;
                    $scope.attendance = result.attendance;
                }
                $scope.themeName = result.theme.name;
                _.defer(() => {
                    $scope.$apply();
                })
            }
        })
        $scope.gotoViewPage = (planId) => {
            $state.go('viewTeachingPlan', {
                planId: planId
            })
        }

    }
}

export default ThemeSummaryController;



// WEBPACK FOOTER //
// ./src/app/authoring-tool/controllers/themeSummaryController.js